var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19.125 19.125c.898 0 1.625.727 1.625 1.625v13a1.625 1.625 0 11-3.25 0v-13c0-.898.727-1.625 1.625-1.625zM30.5 20.75a1.625 1.625 0 10-3.25 0v13a1.625 1.625 0 103.25 0v-13z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.125 2.875A4.876 4.876 0 0014.25 7.75v1.625H2.875a1.625 1.625 0 100 3.25H7.75V40.25a4.876 4.876 0 004.875 4.875h22.75a4.876 4.876 0 004.875-4.875V12.625h4.875a1.625 1.625 0 100-3.25H33.75V7.75a4.876 4.876 0 00-4.875-4.875h-9.75zm11.375 6.5V7.75c0-.897-.729-1.625-1.625-1.625h-9.75c-.896 0-1.625.728-1.625 1.625v1.625h13zM11 12.625V40.25c0 .897.729 1.625 1.625 1.625h22.75c.897 0 1.625-.728 1.625-1.625V12.625H11z","key":1})]);
}

Trash.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Trash;

Trash.default = Trash;
